/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SystemActionPoliciesEntity,
} from '../models/index';
import {
    SystemActionPoliciesEntityFromJSON,
    SystemActionPoliciesEntityToJSON,
} from '../models/index';

/**
 * 
 */
export class MyActionApi extends runtime.BaseAPI {

    /**
     * 自分自身が持つシステム実行ポリシーを一覧で取得する。
     */
    async listMySystemActionPoliciesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SystemActionPoliciesEntity>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/my/systemActionPolicies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SystemActionPoliciesEntityFromJSON));
    }

    /**
     * 自分自身が持つシステム実行ポリシーを一覧で取得する。
     */
    async listMySystemActionPolicies(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SystemActionPoliciesEntity>> {
        const response = await this.listMySystemActionPoliciesRaw(initOverrides);
        return await response.value();
    }

}
